"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[968],{

/***/ 8587:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ConvertExperiences)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



/**
 * * Controls client-side JS for any Convert Experiences needing JS to Run
 * 
 * @options
 * [data-utility="convert-experiences"] {required} - Utility trigger-element
 * 
 */

function ConvertExperiences({ wrapper }) {

  const bespokeExperiencesCatalog = [
    // ! Convert Ref: [PLP A/B](https://app.convert.com/accounts/10042180/projects/10042675/experiences/100487941/summary)
    {
      experienceRefName: 'Page-Specific A/B Test of "Old" PLP vs "New" PLP', // Name is purely referential
      experienceRefDescription: 'Running this test via url-param means that all on-page links will need updated to match the variation that is served to a user ("Old" or "New")', // Description is purely aesthetic
      experienceId: 100487941, // Experience ID is *required*
      triggerUrlParam: null, // Optional string used to identify this test from the frontend
      variations: { // Variation IDs are *required* | Reference descriptions are optional
        default: {
          id: 1004211698, 
          refDescription: 'Old PLP Template'
        },
        variant: {
          id: 1004211699,
          refDescription: 'New PLP Template'
        }  
      },
      bespokeHandler: function() { // Custom handler specific to this experience and/or variations
        handleCollectionLinkUpdates(this) 
      } 
    },


    // ! Convert Ref: [Cart Redesign | Split URL Test](https://app.convert.com/accounts/10042180/projects/10042675/experiences/100438317/summary)
    {
      experienceRefName: 'Global A/B Test of "Old" Slide-Cart vs "New" Slide Cart', // Name is purely referential
      experienceRefDescription: 'Running this test via url-param means that we need to manually ensure the same variation is shown to a user across a session.', // Description is purely aesthetic
      experienceId: 100438317, // Experience ID is *required*
      triggerUrlParam: 'alt-cart', // Optional string used to identify this test from the frontend
      variations: { // Variation IDs are *required* | Reference descriptions are optional
        default: {
          id: 100496669, 
          refDescription: 'Old Cart'
        },
        variant: {
          id: 100496670,
          refDescription: 'New Cart'
        }  
      },
      bespokeHandler: function() { // Custom handler specific to this experience and/or variations
        handleGlobalElementVariations(this) 
      } 
    },


    // ! Convert Ref: [Nav Redesign - 4.16.2025 | Split URL Test](https://app.convert.com/accounts/10042180/projects/10042675/experiences/1004144401/summary)
    {
      experienceRefName: 'Global A/B Test of "Old" Nav vs "New" Nav', // Name is purely referential
      experienceRefDescription: 'Running this test by leveraging Convert-side JS. Storing data within Convert, then persisting within base.js + convert-experiences.js', // Description is purely aesthetic
      experienceId: 1004144698, // !! Experience ID is *required*
      triggerUrlParam: null, // Optional string used to identify this test from the frontend
      variations: { // Variation IDs are *required* | Reference descriptions are optional
        default: {
          id: 1004341959, 
          refDescription: 'Old Nav'
        },
        variant: {
          id: 1004341960,
          refDescription: 'New Nav'
        }  
      },
      bespokeHandler: function() { // Custom handler specific to this experience and/or variations
        handleGlobalElementVariations(this) 
      } 
    }

  ];

  const config = {
    convertExperiencesDataObj: window?.CNVRT, // TS: we are setting CNVRT from within Convert's injected JS -> 'Global Experiment Javascript'
    persistentVariationSessionStorageString: 'cnvrt-show-persisting-variant-global-el'
  }

  
  ;(function init() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('CNVRT:loaded', (e) => { // CustomEvent fires from within Convert Experiences' "Global Experience JS"
      // * this event is the SECONDARY SOURCE for supplying convertExperiencesDataObj w/ data; the PRIMARY SOURCE stores the same context directly on window.CNVRT
      config.convertExperiencesDataObj = e.detail 
      initializeConvert();
    })

    initializeConvert();
  })()


  function initializeConvert() {
    if (!config.convertExperiencesDataObj) return;
    handleBespokeExperiences()
  }


  function handleBespokeExperiences() {
    let activeBespokeExperience = checkForMatchingBespokeExperience();

    if (!!activeBespokeExperience?.bespokeHandler) {
      activeBespokeExperience.bespokeHandler()
    }
  }


  function checkForMatchingBespokeExperience() {
    // * Check if a user has been served a ~Bespoke~ Active Experience by Convert
    // * -> Most Experiences will be able to run themselves; 
    // * -> Some 'Bespoke' Experiences need additional interaction from the frontend (ie, a 'custom' testing format)
    if (!config.convertExperiencesDataObj?.currentExperience?.experience_id) return null; // If session expired, return null

    for (let i = 0; i < bespokeExperiencesCatalog.length; i++) {
      const bespokeExperience = bespokeExperiencesCatalog[i];
      if ( bespokeExperience && (parseInt(bespokeExperience.experienceId) === parseInt(config.convertExperiencesDataObj.currentExperience.experience_id)) ) { // Check for matching Convert Experience ID
        return bespokeExperience; // Return the matching bespokeExperience
      }
    }
  
    return null; // Return null if no match is found
  }


  function handleCollectionLinkUpdates(activeExperienceObject) {
    // * Ensure that, once a user is served one Variation, they ONLY see the corresponding PLP
    // ! 1.) If default is served, do nothing
    // ! 2.) If variant is served, update all corresponding links
    if (config.currentConvertExperienceObj.variation_id !== activeExperienceObject.variations.variant.id) return

    // Get all links that need their hrefs updated
    let $allCollectionLinks = jquery__WEBPACK_IMPORTED_MODULE_0___default()('a[href*="/collections/"]');

    // Use Look-Up Table to transform URL-string
    let plpVariantUrlLUT = {
      "https://branchbasics.com/collections/all": "https://branchbasics.com/collections/all-products",
      "https://branchbasics.com/collections/all#starter-kits": "https://branchbasics.com/collections/starter-kits",
      "https://branchbasics.com/collections/all#refills": "https://branchbasics.com/collections/refills",
      "https://branchbasics.com/collections/all#accessories": "https://branchbasics.com/collections/accessories",
      "https://branchbasics.com/collections/all#travel": "https://branchbasics.com/collections/all-products?filter.p.m.filters.product_category=Travel&sort_by=manual"
    };

    $allCollectionLinks.each((index, link) => {
      if (plpVariantUrlLUT[link.href] === undefined) return;
      link.href = plpVariantUrlLUT[link.href];
    })
  }
  

  function handleGlobalElementVariations(activeExperienceObject) {
    // * Ensure that, once a user is served a Test Variation, they ONLY see the corresponding Global Element
    // ! JS from Convert Experiment *should* store the correct reference (Original/Variant), but this JS exists to account for existing slippage 
    // ! 1.) If default is served -> show and persist default Element + hide Variant Element
    // ! 2.) If variant is served -> hide default Element + show and persist Variant Element

    handleSessionPersistence(activeExperienceObject);
  }


  function handleSessionPersistence(activeExperienceObject) {
    // todo: update 'true'/'false' values below to instead use either 1.) 'original'/'variant' OR 2.) use the associated variant.id coming from Convert..

    let storedPersistingVariantParamVal = sessionStorage.getItem(config.persistentVariationSessionStorageString); // will return either 'true' or 'false'
    let finalPersistingVariantParamVal = 'false'; // default to 'false' (aka, persisting the Original)

    console.log("trying to handleSessionPersistence => activeExperienceObject: ", activeExperienceObject)
    console.log("trying to handleSessionPersistence => config.convertExperiencesDataObj.currentExperience: ", config.convertExperiencesDataObj.currentExperience)

    // * If an experience has a configured triggerUrlParam, check for its presence in urlParams
    if (!activeExperienceObject.triggerUrlParam) {
      let currentUrlObj = new URL(window.location.href);
      let currentParamsMap = currentUrlObj.searchParams;

      if (currentParamsMap.has(activeExperienceObject.triggerUrlParam)) { // If URL Params contain activeTriggerParam => we know that we are being served the VARIANT, persist VARIANT
        finalPersistingVariantParamVal = 'true'; 
      } else { // Otherwise, URL Params do NOT contain activeTriggerParam => we know that we are being served the ORIGINAL, persist ORIGINAL
        finalPersistingVariantParamVal = 'false';
      }
    }


    // * IF a value has already been set for activeTriggerParam in sessionStorage, persist the value from sessionStorage
    if (!!storedPersistingVariantParamVal) {
      finalPersistingVariantParamVal = storedPersistingVariantParamVal
    // * ELSE NO value has been set for activeTriggerParam in sessionStorage yet (OR it has expired) => Store finalPersistingVariantParamVal to sessionStorage to enable quicker retrieval in base.js
    } else {
      sessionStorage.setItem(config.persistentVariationSessionStorageString, finalPersistingVariantParamVal)
    } 

    revealActiveGlobalElement(finalPersistingVariantParamVal)
  }
  

  function revealActiveGlobalElement(persistingVariantParamVal) {
    // check to make sure base.js did not already remove one of our Variants (prevent accidentally removing BOTH)
    let $persistingVariantNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-cnvrt-persisting-variant-global-el="${persistingVariantParamVal}"]`)
    console.log("trying to revealActiveGlobalElement.... $persistingVariantNode: ", $persistingVariantNode)

    if (!$persistingVariantNode || $persistingVariantNode.length === 0) return;
    
    let reciprocalPersistingVariantParamVal = persistingVariantParamVal === 'true' ? 'false' : 'true'; // inverting 'true'/'false' strings
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').attr('data-cnvrt-show-persisting-variant-global-el', persistingVariantParamVal);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-cnvrt-persisting-variant-global-el="${reciprocalPersistingVariantParamVal}"]`).remove();
    $persistingVariantNode.addClass('active-cnvrt-variant');

    // update navheight
    let $activeNavbar = $persistingVariantNode.find('[data-primary-nav]:visible');
    let activeNavbarHeight = $activeNavbar.outerHeight();
    document.documentElement.style.setProperty('--navbar-height', `${activeNavbarHeight}px`)
  }


}

/***/ })

}]);